import React from 'react'
import PropTypes from 'prop-types'

import ContentBlock from '../components/ContentBlock'
import FeaturesBlock from '../components/FeaturesBlock'
import LocationMap from '../components/LocationMap'
import Slider from '../components/Slider'

import localization from '../localization/thehouse'

import img_featuresSlider1 from '../assets/thehouse/featuresSlider1.jpg'
import img_featuresSlider2 from '../assets/thehouse/featuresSlider2.jpg'
import img_featuresSlider3 from '../assets/thehouse/featuresSlider3.jpg'
import img_featuresSlider4 from '../assets/thehouse/featuresSlider4.jpg'
import img_featuresSlider5 from '../assets/thehouse/featuresSlider5.jpg'
import img_featuresSlider6 from '../assets/thehouse/featuresSlider6.jpg'

import img_history from '../assets/thehouse/history.jpg'
import img_kopp from '../assets/thehouse/kopp.jpg'

const TheHousePage = (props) => {
  const { language } = props

  const sliderImages = [
    { image: img_featuresSlider1, alt: localization[language].featuresSlider1Alt },
    { image: img_featuresSlider2, alt: localization[language].featuresSlider2Alt },
    { image: img_featuresSlider3, alt: localization[language].featuresSlider3Alt },
    { image: img_featuresSlider4, alt: localization[language].featuresSlider4Alt },
    { image: img_featuresSlider5, alt: localization[language].featuresSlider5Alt },
    { image: img_featuresSlider6, alt: localization[language].featuresSlider6Alt }
  ]

  return (
    <React.Fragment>
      <ContentBlock darkBackground>
        <h1 className="t-heading-xl">{localization[language].title}</h1>
      </ContentBlock>

      <ContentBlock split sliderRight>
        <div>
          <h2 className="t-heading-s">{localization[language].featuresTitle}</h2>
          <p>{localization[language].featuresP1}</p>
          <p>{localization[language].featuresP2}</p>
        </div>

        <div>
          <Slider images={sliderImages} />
        </div>
      </ContentBlock>

      <FeaturesBlock language={language} />

      <ContentBlock split reverse>
        <div>
          <h2 className="t-heading-s">{localization[language].historyTitle}</h2>
          <p>{localization[language].historyP1}</p>
          <p>{localization[language].historyP2}</p>
        </div>

        <div style={{ backgroundImage: `url(${img_history})` }} />
      </ContentBlock>

      <ContentBlock split>
        <div>
          <h2 className="t-heading-s">{localization[language].koppTitle}</h2>
          <p>{localization[language].koppP1}</p>
          <p>{localization[language].koppP2}</p>
          <p>{localization[language].koppP3}</p>
        </div>

        <div style={{ backgroundImage: `url(${img_kopp})` }} />
      </ContentBlock>
      <LocationMap />
    </React.Fragment>
  )
}

TheHousePage.propTypes = {
  language: PropTypes.string.isRequired,
}

export default TheHousePage



// WEBPACK FOOTER //
// ./src/pages/thehouse.js